import { useSelector } from 'react-redux';
import { pickModuleNewEditLists, resolveNewEditVisibilityFlag, shouldUsePreDriFieldLists } from '../helpers/moduleConfigPreNewEditHelper';

const useModuleNewEditFields = (moduleKey, options = {}) => {
  const moduleConfig = useSelector((state) => state.moduleConfig);
  const userRole = useSelector((state) => state.userRole);
  const decision = {
    userRole,
    record: options.record,
    process: options.process || moduleKey,
    forcePre: options.forcePre,
    forceFull: options.forceFull
  };
  const isPreManager = shouldUsePreDriFieldLists(decision);
  return {
    isPreManager,
    visibilityFlag: resolveNewEditVisibilityFlag(decision),
    ...pickModuleNewEditLists(moduleConfig, moduleKey, isPreManager)
  };
};

export default useModuleNewEditFields;
